const config = {
  API_URL: process.env.REACT_APP_API_URL || "https://craftifyproductions.com/api",
};

export default config; 